import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { firstValueFrom, Observable, throwError } from 'rxjs';
import { environment } from './../environments/environment';
import { IFatura } from './../interfaces/ifatura';
import { IFaturaDetalhadaAPI } from '../interfaces/ifatura-detalhada-api';
import { AccessInfo } from '../utils/access-info';
import { IAgendaEduAccessInfo } from '../interfaces/iagenda-edu-access-info';

import { IEnableColigada } from './../interfaces/ienable-coligada';

@Injectable({
  providedIn: 'root',
})
export class FaturaService {
  apiBaseUrl: string = environment.apiBaseUrl;
  EnablePixForAllColigada: boolean = environment.EnablePixForAllColigada
  EnablePixForColigada: IEnableColigada[] = environment.EnablePixForColigada

  constructor(private http: HttpClient) {}

  setFaturas(value: IFatura[]) {
    sessionStorage.setItem('faturas', JSON.stringify(value));
  }

  getFaturasStored(): IFatura[] {
    let faturasParsed = [];
    const storedItem = sessionStorage.getItem('faturas');
    if (storedItem && storedItem != 'null' && storedItem != 'undefined') {
      faturasParsed = JSON.parse(storedItem);
    }
    return faturasParsed;
  }

  getFaturaDetails(fatura: IFatura): Observable<IFaturaDetalhadaAPI> {
    const accessInfo = AccessInfo.getAccessInfo();
    return this.http.get<IFaturaDetalhadaAPI>(
      `${this.apiBaseUrl}agendaedu/boletodetalhe?bankSliptId=${fatura.bankSliptId}&codColigada=${fatura.codColigada}&codFilial=${fatura.codFilial}&isMD=${fatura.isMD}`,
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${accessInfo.accessToken}`,
        },
      }
    );
  }

  getFaturaDetailsPix(fatura: IFatura): Observable<IFaturaDetalhadaAPI> {
    const accessInfo = AccessInfo.getAccessInfo();
    return this.http.get<IFaturaDetalhadaAPI>(
      `${this.apiBaseUrl}agendaedu/pixdetalhe?bankSliptId=${fatura.bankSliptId}&codColigada=${fatura.codColigada}&codFilial=${fatura.codFilial}&isMD=${fatura.isMD}&value=${fatura.value}`, 
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${accessInfo.accessToken}`,
        },
      }
    );
  }

  async getCanSendPix (fatura: IFatura) {
    const accessInfo = AccessInfo.getAccessInfo();
    const resp = await firstValueFrom(await this.http.get(
      `${this.apiBaseUrl}students/${accessInfo.studentId}/commitments/${accessInfo.mainStudentServiceId}/cansendpix`,
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${accessInfo.accessToken}`,
        },
      }
    ));
    return resp
  }

  async canSendPix(fatura: IFatura) {

    if (fatura.isOverdue) {
      return false
    }

    if (!this.EnablePixForAllColigada) {
      if (!this.EnablePixForColigada.some(el => el.id === fatura.codColigada)) {
        return false
      } else {

        const index = this.EnablePixForColigada.findIndex(object => {
          return object.id === fatura.codColigada;
        });

        if (index < 0) return false

        if (!this.EnablePixForColigada[index].filiais.some(el => el == fatura.codFilial)) {
          return false
        }
      }
    }
    return await this.getCanSendPix(fatura)
  }




  async getFaturasByServiceIds(
    studentServiceIds: string[],
    accesstoken: string
  ): Promise<IFatura[]> {
    let faturas: Array<IFatura> = [];
    const promises: Array<Promise<IFatura[]>> = [];

    let index = 0;
    while (index < studentServiceIds.length) {
      let ids = studentServiceIds.slice(index, index + 5);
      if (ids.length > 0) {
        promises.push(
          Promise.resolve(
            firstValueFrom(this.getFaturasAgendaEDU(ids, accesstoken))
          )
        );
      }
      index += 5;
    }

    await Promise.all(promises).then(async (listFaturas) => {
      for (let i = 0; i < listFaturas.length; i++) {
        const element = listFaturas[i];
        faturas = faturas.concat(element);
      }
    });

    return faturas;
  }

  getLinkPortal(studentId: string) {
    let accessInfo: IAgendaEduAccessInfo = AccessInfo.getAccessInfo();
    return this.http.get(
      `${this.apiBaseUrl}students/negotiation-link/get-self-link/${accessInfo.studentId}`,
      {
        headers: {
          Authorization: `Bearer ${accessInfo.accessToken}`,
          'Content-Type': 'application/json',
          'x-origin-project': 'AGENDAEDU',
        },
      }
    );
  }

  private getFaturasAgendaEDU(
    studentServiceIds: string[],
    accesstoken: string
  ): Observable<IFatura[]> {
    let params: string = '';
    studentServiceIds.forEach((value: string) => {
      params += `studentServiceIds=${value}&`;
    });
    return this.http.get<IFatura[]>(
      `${this.apiBaseUrl}bankslipts/agendaEdu?${params}banksliptStatus=1`,
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${accesstoken}`,
        },
      }
    );
  }
}
